<template>
    <div>
        <h2 class="uk-modal-title uk-margin-small-bottom"><slot></slot></h2>
        <div v-if="this.filter" class="uk-align-right@m uk-margin-remove-bottom recipients">
            All Filtered Recipients Selected
        </div>
        <div v-else-if="requisition" class="recipients uk-margin-small-bottom">
            <div class="uk-grid">
                <div class="uk-width-1-2">
                    <select class="uk-select" v-model="shiftId">
                        <option v-for="shift in shiftOptions" :value="shift.id" >{{shift.name}}</option>
                    </select>
                </div>
                <div class="uk-width-1-2 uk-text-right uk-text-bottom">
                    {{ ids.length }} Recipients Selected
                </div>
            </div>
        </div>
        <div v-else class="uk-align-right@m uk-margin-remove-bottom recipients">
            {{ ids.length }} Recipients Selected
        </div>
        <div class="uk-clearfix"></div>
        <div style="margin-bottom: 15px;">
            <label for="message-field" class="uk-form-label">Message Title </label>
            <div class="uk-form-controls">
                <input id="name-field" type="text" class="uk-input" name="group_name" v-model="messageName" />
            </div>
        </div>
        <div>
            <label for="message-field" class="uk-form-label header">Compose Message <span class="uk-align-right uk-margin-remove">{{ message.length }}/{{ messageMaxSize }}</span></label>
            <div class="uk-form-controls">
                <textarea id="message-field" class="uk-textarea bottom-border" name="message" v-model="message"></textarea>
            </div>
        </div>
        <div class="uk-margin-medium-bottom"></div>
        <div class="uk-align-right">
            <!--button class="uk-button uk-button-tertiary" type="button" @click="cancel()"><i class="fas fa-times-circle"></i> Cancel</button-->
            <button class="uk-button uk-button-primary" type="submit"><i class="fas fa-comment fa-flip-horizontal"></i> Send Message</button>
        </div>
        <div class="data-table">
            <table ref="table" cellspacing="0" cellpadding="0">
                <thead>
                <tr>
                    <template v-if="!isLoading">
                        <th>
                            X
                        </th>
                        <th class="sortable" @click="sortPersons('name', $event)">Name
                            <i class='fa fa-sort-down' v-if="currentSortField == 'name'"></i>
                        </th>
                        <th class="sortable" @click="sortPersons('job', $event)">Job
                            <i class='fa fa-sort-down' v-if="currentSortField == 'job'"></i>
                        </th>
                        <th>Phone</th>
                        <th class="sortable" @click="sortPersons('shift', $event)">Shift
                            <i class='fa fa-sort-down' v-if="currentSortField == 'shift'"></i>
                        </th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th class="sortable" @click="sortPersons('dropped', $event)">Removed
	                        <i class='fa fa-sort-down' v-if="currentSortField == 'dropped'"></i>
                        </th>
                    </template>
                </tr>
                </thead>
                <tbody>
                <!-- data rows -->
                <template v-if="!isLoading" v-for="(row,index) in persons">
                    <tr >
                        <td>
                            <input ref="chbox" type="checkbox" class="uk-checkbox" name="person_ids[]" v-model="ids" :value="row.id" />
                        </td>
                        <td>{{ row.full_name }}</td>
                        <td>{{ row.job_name }}</td>
                        <td>{{ row.phone }}</td>
                        <td>{{ row.shifts }}</td>
                        <td v-html="displayDateList(row.start_dates)"></td>
                        <td v-html="displayDateList(row.end_dates)"></td>
                        <td>{{ row.dropped ? "X":"" }}</td>
                    </tr>
                </template>

                <!-- no data is available for table -->
                <tr v-if="isLoading" >
                    <td colspan="1"><img style="width: 18px;" src="/images/spinner2.gif" /> Loading...</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SMSForm",

        props:{
            personIds:{type: Array, default:function(){return []}},
            requisitionId:{type: Number, default: 0}
        },

        data(){
            return {
                ids: [],
                filter: null,
                messageName:"",
                message: "",
                requisition: null,
                messageMaxSize:160,
                displayWarning: false,
                shiftOptions: [
                    {
                        id: 0,
                        name: "All Shifts"
                    }
                ],
                isLoading: true,
                persons: [],
                allSelected: false,
                currentSortField: null,
                currentSortDir: "asc",
            }
        },

        mounted(){
            this.requestPersons();
        },

        methods:{
            submitForm(){
                if(this.ids.length > 0){
                    axios.post("/api/message/send", {
                        person_ids: this.ids,
                        group_name: this.messageName,
                        message:this.message
                    }).then(() => this.showConfirmation());
                } else if (this.filter != null){
                    axios.post("/api/message/send", {
                        filter: this.filter,
                        group_name: this.messageName,
                        message:this.message
                    }).then(() => this.showConfirmation());
                }

            },
            requestPersons(){
                axios.get("/api/requisition/sms/" + this.requisitionId).then(
                    (pack) => this.updatePersons(pack),
                    (pack) => this.updatePersons(pack),
                )
            },
            updatePersons(pack){
                if(pack.data.success){
                    this.persons = pack.data.data;
                }
                this.isLoading = false;
                for(let i = 0; i < this.persons.length;++i){
                    let person = this.persons[i];
                    if(!person.dropped && !person.no_default && person.phone != null && person.phone !== ""){
                        this.ids.push(person.id);
                    }
                }
            },
            /*showConfirmation(){
                UIkit.modal("#"+this.modalId+"_confirm").show();
            },*/
            setSendIds(arr){
                this.ids = arr;
                this.filter = null;
            },
            addSendId(id){
                this.ids.push(id);
                this.filter = null;
            },
            setFilterCriteria(filter){
                this.filter = filter;
                this.ids = [];
            },
            cancel(){
                this.message = "";
            },
            displayDateList(dates){
                if(dates == undefined || dates == null || dates.length == 0){
                    return "-";
                }
                let returnString = "";
                for(let i = 0; i < dates.length;++i){
                    returnString += "<div>" + dates[i] + "</div>";
                }
                return returnString;
            },
            sortPersons(field, event){
                let el = event.target;
                //reset css classes
                let sortables = this.$el.getElementsByClassName("sortable");
                for(let i = 0; i < sortables.length;++i){
                    sortables[i].classList.remove("sorting");
                    sortables[i].classList.remove("asc");
                    sortables[i].classList.remove("desc");
                }
                el.classList.add("sorting");
                if(this.currentSortField == field){
                    if(this.currentSortDir == "asc"){
                        this.currentSortDir = "desc";
                    } else {
                        this.currentSortDir = "asc";
                    }
                } else {
                    this.currentSortDir = "asc";
                }
                el.classList.add(this.currentSortDir);
                this.currentSortField = field;
                //actually sort the data
                switch(this.currentSortField){
                    case "name":
                            if(this.currentSortDir == "desc"){
                                this.persons.sort((a,b) => (a.full_name > b.full_name) ? -1:1);
                            } else {
                                this.persons.sort((a,b) => (a.full_name < b.full_name) ? -1:1);
                            }
                        break;
                    case "job":
                            if(this.currentSortDir == "desc"){
                                this.persons.sort((a,b) => (a.job_name > b.job_name) ? -1:1);
                            } else {
                                this.persons.sort((a,b) => (a.job_name < b.job_name) ? -1:1);
                            }
                        break;
                    case "shift":
                            if(this.currentSortDir == "desc"){
                                this.persons.sort((a,b) => (a.shifts > b.shifts) ? -1:1);
                            } else {
                                this.persons.sort((a,b) => (a.shifts < b.shifts) ? -1:1);
                            }
                        break;
	                case "dropped":
		                if(this.currentSortDir == "desc"){
			                this.persons.sort((a,b) => (a.dropped > b.dropped) ? -1:1);
		                } else {
			                this.persons.sort((a,b) => (a.dropped < b.dropped) ? -1:1);
		                }
						break;
                }
            }
        },

        watch:{
            message(){
                if(this.message.length > 160){
                    this.message = this.message.substr(0, this.messageMaxSize);
                }
            }
        }
    }
</script>

<style scoped>

</style>
